export function debounce(func, timeout) {
  if (func == null) throw new Error('debounce function is null');
  let timer;
  return function (...rest) {
    clearTimeout(timer);
    timer = setTimeout(() => func(...rest), timeout);
  };
}
